import { render, staticRenderFns } from "./ChartOfAccountForm.vue?vue&type=template&id=37bfb935"
import script from "./ChartOfAccountForm.vue?vue&type=script&lang=js"
export * from "./ChartOfAccountForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports